import React, { useEffect, useRef } from "react";
import { Doughnut } from "react-chartjs-2";

export function DoughnutChart(props) {
  const customToolTipTitle = useRef(null);
  const customToolTipValue = useRef(null);
  const graphContainer = useRef(null);

  const handleClick = (event, elements) => {
    if (elements.length > 0) {
      const index = elements[0].index;
      const label = props.data.labels[index];
      const value = props.data.datasets[0].data[index];
      const backgroundColor = props.data.datasets[0].backgroundColor[index];

      if (props.onSegmentClick) {
        props.onSegmentClick({ label, value, backgroundColor });
      }
    }
  };

  const handleHover = (event, chartElement) => {
    const canvas = event.chart.canvas;

    if (chartElement.length > 0) {
      canvas.style.cursor = "pointer";
    } else {
      canvas.style.cursor = "default";
    }
  };

  const customOptions = {
    elements: {
      arc: {
        borderWidth: 2,
        hoverBorderWidth: 6,
        hoverOffset: -6,
        borderJoinStyle: "miter",
        hoverBorderJoinStyle: "miter"
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false,
        callbacks: {
          ...(props.disableCustomToolTip
            ? {}
            : {
                label: function(context) {
                  const label = context.label || "";
                  const value = context.raw || "";
                  return { label: label, value: value };
                }
              })
        },
        position: "average",
        external: props.disableCustomToolTip
          ? undefined
          : function(context) {
              const tooltip = context.tooltip;
              const chart = context.chart;
              const chartPosition = chart.canvas.getBoundingClientRect();

              updateCustomToolTip(
                tooltip,
                true,
                {
                  defaultValue: props.data.defaultValue,
                  ref: customToolTipTitle,
                  fontSize: "10px",
                  leftOffset: 4,
                  topOffset: -30
                },
                chartPosition,
                chart
              );
              updateCustomToolTip(
                tooltip,
                false,
                {
                  defaultValue: props.data.defaultValue,
                  ref: customToolTipValue,
                  fontSize: "16px",
                  leftOffset: 4,
                  topOffset: -4
                },
                chartPosition,
                chart
              );
            }
      }
    },
    cutout: "90%",
    responsive: true,
    maintainAspectRatio: false,
    onClick: typeof props.onSegmentClick === "function" ? handleClick : null,
    onHover: typeof props.onSegmentClick === "function" ? handleHover : null
  };
  useEffect(() => {
    graphContainer.current.style.position = "relative";
    if (customToolTipTitle.current && props.data.defaultValue?.label) {
      customToolTipTitle.current.style.width = `${graphContainer.current.clientWidth}px`;
      customToolTipTitle.current.style.position = "absolute";
      customToolTipTitle.current.style.bottom = "60%";
      customToolTipTitle.current.style.zIndex = 2;
      customToolTipTitle.current.style.color = "var(--tertiaryColor6)";
      customToolTipTitle.current.style.fontSize = "10px";
      customToolTipTitle.current.style.whiteSpace = "no-wrap";
      customToolTipTitle.current.style.display = "flex";
      customToolTipTitle.current.style.flexDirection = "column";
      customToolTipTitle.current.style.justifyContent = "center";
      customToolTipTitle.current.style.alignItems = "center";
      customToolTipTitle.current.innerHTML = props.data.defaultValue.label;
    }
    if (
      customToolTipValue.current &&
      typeof props.data.defaultValue?.value?.toString() === "string"
    ) {
      customToolTipValue.current.style.width = `${graphContainer.current.clientWidth}px`;
      customToolTipValue.current.style.fontSize = "16px";
      customToolTipValue.current.style.color = "var(--tertiaryColor)";
      customToolTipValue.current.style.zIndex = 2;
      customToolTipValue.current.style.whiteSpace = "no-wrap";
      customToolTipValue.current.style.display = "flex";
      customToolTipValue.current.style.flexDirection = "column";
      customToolTipValue.current.style.justifyContent = "center";
      customToolTipValue.current.style.alignItems = "center";
      customToolTipValue.current.innerHTML = props.data.defaultValue.value;
    }
    // eslint-disable-next-line
  }, [props.data?.defaultValue, graphContainer?.current?.clientWidth]);

  return (
    <div className="inherit-parent-height flex-align-items-center flex-direction-column">
      <div
        ref={graphContainer}
        className="inherit-parent-height display-flex flex-align-items-center"
      >
        <Doughnut
          data={props.data}
          options={customOptions}
          style={{ ...props.style, zIndex: 1 }}
          className="height-width"
        />
        <div
          ref={customToolTipTitle}
          style={{
            position: "absolute"
          }}
          className="display-flex flex-align-items-center flex-justify-content-center"
        />
        <div
          ref={customToolTipValue}
          style={{
            position: "absolute"
          }}
          className="display-flex flex-align-items-center flex-justify-content-center"
        />
      </div>
    </div>
  );
}

const updateCustomToolTip = (tooltip, label, data) => {
  if (tooltip?.body) {
    data.ref.current.innerHTML = tooltip.body
      ?.map((bodyItem) => bodyItem.lines[0]?.[label ? "label" : "value"])
      .join("<br>");
  }

  if (tooltip.opacity === 0) {
    data.ref.current.innerHTML = data.defaultValue?.[label ? "label" : "value"];
  }
};
